import React from 'react';
import { LocalizedHtml, useI18n } from '@udemy/i18n';
import { Badge } from '@udemy/react-messaging-components';
import { ProBadge } from '@udemy/react-pro-content';
import styles from "../../../mobile/mobile-nav/mobile-nav.module.css";
import { MobileNavL2Nav, MobileNavSection, MobileNavItem } from '../../../mobile/mobile-nav/mobile-nav.react-component';
import { levelTwoNavIdMap } from '../level-one/mobile-l1-manage-nav.react-component';
export const MobileL2ManageNav = ({
  l1NavItem
}) => {
  var _l1NavItem$children;
  const {
    gettext
  } = useI18n();
  function getTitle(item) {
    let title = item.title;
    if (item.is_pro) {
      title = /*#__PURE__*/React.createElement(React.Fragment, null, title, " ", /*#__PURE__*/React.createElement(ProBadge, null));
    } else if (item.is_beta) {
      title = /*#__PURE__*/React.createElement(LocalizedHtml, {
        html: interpolate(gettext('%(title)s <span class="beta">Beta</span>'), {
          title
        }, true),
        interpolate: {
          beta: /*#__PURE__*/React.createElement(Badge, {
            className: styles.beta
          })
        }
      });
    }
    return title;
  }
  return /*#__PURE__*/React.createElement(MobileNavL2Nav, {
    id: levelTwoNavIdMap[l1NavItem.id],
    "data-testid": "mobile-l2-manage-nav",
    l1NavId: "header-toggle-side-nav-manage",
    l1NavTitle: gettext('Manage')
  }, /*#__PURE__*/React.createElement(MobileNavSection, null, (_l1NavItem$children = l1NavItem.children) === null || _l1NavItem$children === void 0 ? void 0 : _l1NavItem$children.map(item => /*#__PURE__*/React.createElement(MobileNavItem, {
    key: item.key,
    href: item.href
  }, getTitle(item)))));
};
//# sourceMappingURL=mobile-l2-manage-nav.react-component.js.map